"use client"

import PrimaryButton from "@/components/buttons/PrimaryButton"
import Image from "@/components/Image"
import { CallToActionBanner } from "@/components/sections"
import { BodySmall, Heading1 } from "@/components/text"
import { useRouter } from "next/navigation"

export interface BaseErrorProps {
  code?: string
}

const ErrorPage: React.FC<BaseErrorProps> = ({ code }) => {
  const router = useRouter()

  const renderHeader = () => {
    let id = "error_unknown_title"
    let defaultMessage = "Er is een fout opgetreden"
    let description = "error occurred."

    switch (code) {
      case "404":
        id = "error_404_title"
        defaultMessage = "Doesn't exist!"
        description = "This page doesn't exist"
        break
      case "410":
        defaultMessage = "Service unavailable"
        id = "error_410_title"
        description = "title on error page. this page is no longer available."
        break
      case "503":
        id = "error_503_title"
        defaultMessage = "Error Occurred"
        description = "Error page title, we don't know what happened but will come back soon"
        break
      case "9999":
        id = "error_9999"
        defaultMessage = "Er ging iets verkeerd"
        description = "Er ging iets verkeerd"
        break
    }
    return defaultMessage
  }

  const renderMessage = () => {
    let id = "error_unknown"
    let defaultMessage = "Er is iets fout gegaan! Probeer het later opnieuw of neem contact op met info@goodshift.nl"
    let description = "unknown error"

    switch (code) {
      case "404":
        id = "error_404"
        defaultMessage = "This page doesn't exist"
        description = "This page doesn't exist"
        break
      case "410":
        id = "error_410"
        defaultMessage = "This action is not longer available"
        description = "error description. Requested charity was is no longer available"
        break
      case "503":
        id = "error_503"
        defaultMessage = "Sorry our service is temporary unavailable. We doing all our best to come back soon"
        description = "error explanation and apology"
        break
      case "9999":
        id = "error_9999"
        defaultMessage = "Probeer het opnieuw of pas je betaal gegevens aan."
        description = "Probeer het opnieuw of pas je betaal gegevens aan."
        break
    }
    return defaultMessage
  }

  return (
    <>
      <div className="px-4 mx-auto max-w-7xl">
        <div className="flex flex-col bg-white w-full text-center">
          <Image
            className="m-auto"
            url={"/goodshift/img/icons/error_orange.svg"}
            height={120}
            width={120}
            alt="Error!"
          />
          <Heading1>{renderHeader()}</Heading1>
          <BodySmall>{renderMessage()}</BodySmall>
          <div className="max-w-[60%] m-auto px-12 mb-12">
            <PrimaryButton
              type="submit"
              onClick={() => {
                router.back()
              }}>
              <Image
                className="inline w-6 h-6 mr-2"
                url={"/goodshift/img/icons/hand_heart_white.svg"}
                height={24}
                width={24}
                alt=""
              />
            </PrimaryButton>
          </div>

          <CallToActionBanner />
        </div>
      </div>
    </>
  )
}
export default ErrorPage
